import {UserRole} from "../user-role/user-role.model";

export interface User {
  id: string
  uniqueId: string
  firstName?: string
  lastName?: string
  email?: string
  phone: string
  photo: string
  accountType: AccountTypesChoices
  role: UserRole
  isActive: boolean
  createdDate?: string
}


export enum UserTitleChoices {
  MR="MR",
  MRS="MRS",
  MISS="MISS",
  MS="MS",
  DR="DR",
  PROF="PROF",
  ENG="ENG",
  OTHER="OTHER",
}

export enum UserGenderChoices {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum AccountTypesChoices {
  STAFF = 'STAFF',
  SUPERVISOR = 'SUPERVISOR',
  EXECUTIVE = 'EXECUTIVE',
  SYSTEM_ADMIN = 'SYSTEM_ADMIN'
}
